import React, { useContext, useEffect } from "react";
import ProductFilter from "./ProductFilter";
import ProductForm from "./ProductForm";
import Products from "./Products";
import ProductContext from "../../context/products/ProductContext";
import Spinner from "../layout/Spinner";

const ProductHome = () => {
  const productContext = useContext(ProductContext);
  const { products, getProducts } = productContext;

  useEffect(() => {
    getProducts();
  }, []);

  return products !== null ? (
    <div className="row m-0">
      <div className="col-sm-3">
        <ProductFilter />
        <Products />
      </div>{" "}
      <div className="col-sm-9">
        <ProductForm />
      </div>{" "}
    </div>
  ) : (
    <div
      className="d-flex mx-auto my-auto"
      style={{
        height: "80vh",
      }}
    >
      <Spinner />
    </div>
  );
};

export default ProductHome;
